/** @jsx jsx */
import { jsx } from '@emotion/core'
import api from 'api'
import { Button, Icon, Tooltip } from 'bold-ui'
import { MChatRiscoEnum } from 'graphql/types.generated'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { reportFormatDate, useHandleImpressao } from 'hooks/impressao/useHandleImpressao'
import { isEmpty } from 'lodash'

import { MChatRfAccordionSection } from '../../components/MChatRfAccordionSection'
import { MChatRfAccordionStepper } from '../../components/MChatRfAccordionStepper'
import { MChatRfAccordionSectionEnum } from '../../model-mChatRf'
import { convertMChatToPerguntaRespostaInput } from '../converter-mchat'
import { MChatAnteriorFooterInfoModel, MChatFieldModel } from '../model-mchat'

interface MChatViewProps {
  value: MChatFieldModel & MChatAnteriorFooterInfoModel
}

export function MChatView(props: Readonly<MChatViewProps>) {
  const { value } = props

  const {
    atendimentoProfissional: { id: atendProfId },
    cidadao: { id: cidadaoId },
  } = useAtendimentoContext()

  const { handleImpressaoPath } = useHandleImpressao()

  const hasValuesMChat = !isEmpty(value)

  const handlePrint = (mchat: MChatFieldModel) => {
    const input = {
      atendProfId: hasValuesMChat ? value.atendimentoProfissionalId : atendProfId,
      cidadaoId: cidadaoId,
      resultado: mchat.resultado,
      risco: mchat.risco,
      aplicacao: convertMChatToPerguntaRespostaInput(mchat),
    }

    handleImpressaoPath({
      apiPath: api.mchat.imprimirMChat,
      values: input,
      file: `MChat.pdf`,
      dateFormat: reportFormatDate,
    })
  }

  return (
    <MChatRfAccordionSection
      section={MChatRfAccordionSectionEnum.MCHAT}
      value={value}
      stepper={
        <MChatRfAccordionStepper
          showPendingIcon={!hasValuesMChat}
          showCheckIcon={hasValuesMChat}
          showConnector={value?.risco === MChatRiscoEnum.MEDIO}
          showExclamationIcon={false}
        />
      }
      secondaryActions={
        <Tooltip text='Imprimir'>
          <Button type='button' kind='normal' skin='ghost' size='small' onClick={() => handlePrint(value)}>
            <Icon icon='printerOutline' />
          </Button>
        </Tooltip>
      }
      footerInfo={value}
    />
  )
}
